export default __webpack_public_path__ + "static/media/chordates.b1ec93ed.png";